/* NK - Dúvidas frequentes: animação suave de altura no <details> (sem JS o accordion funciona nativamente) */
if (!customElements.get('tp-nk-faq')) {
  class TpNkFaq extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      const summary = event.target.closest('summary');
      if (!summary || !this.contains(summary)) return;

      const details = summary.parentElement;
      const panel = details.querySelector('[data-faq-answer]');
      if (!panel || this.reduceMotion.matches || typeof panel.animate !== 'function') return;

      event.preventDefault();
      if (details.dataset.animating === 'true') return;

      if (details.open) {
        this.close(details, panel);
      } else {
        this.open(details, panel);
      }
    }

    open(details, panel) {
      details.dataset.animating = 'true';
      details.open = true;
      const height = panel.scrollHeight;
      const animation = panel.animate(
        [
          { height: '0px', opacity: 0 },
          { height: `${height}px`, opacity: 1 },
        ],
        { duration: 300, easing: 'ease' }
      );
      animation.onfinish = animation.oncancel = () => {
        delete details.dataset.animating;
      };
    }

    close(details, panel) {
      details.dataset.animating = 'true';
      details.classList.add('tp-nk-faq__item--closing');
      const height = panel.offsetHeight;
      const animation = panel.animate(
        [
          { height: `${height}px`, opacity: 1 },
          { height: '0px', opacity: 0 },
        ],
        { duration: 250, easing: 'ease' }
      );
      animation.onfinish = animation.oncancel = () => {
        details.open = false;
        details.classList.remove('tp-nk-faq__item--closing');
        delete details.dataset.animating;
      };
    }
  }

  customElements.define('tp-nk-faq', TpNkFaq);
}
